import React, { useState } from 'react';
import './index.css';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import { ReactComponent as CheckIcon } from 'common/icons/table-check.svg';
import numberWithSpaces from 'common/utils/numberWithSpaces';
import { ReactComponent as KimsLogo } from './icons/kims.svg';
import { ReactComponent as SmallKimsLogo } from './icons/small_kims.svg';
import { ReactComponent as FacebookLogo } from './icons/facebook.svg';
import { ReactComponent as TwitterLogo } from './icons/twitter.svg';
import { ReactComponent as InstagramLogo } from './icons/instagram.svg';
import { ReactComponent as TelegramLogo } from './icons/telegram.svg';
import Button from 'common/components/Button';
import { Navigate, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { TableNavButton } from 'common/styles/TableNavButton';
import Banner from './images/banner.png';
import { ReactComponent as LocationIcon } from 'common/icons/location.svg';
import { ReactComponent as PhoneIcon } from 'common/icons/phone.svg';
import { ReactComponent as MailIcon } from 'common/icons/mail.svg';
import { ReactComponent as GlobeIcon } from 'common/icons/globe.svg';
import { ReactComponent as StarIcon } from 'common/icons/star.svg';
import { ReactComponent as HorizontalDotsIcon } from 'common/icons/dots-horizontal.svg';
import { ReactComponent as PlayIcon } from './icons/play.svg';
//import { ReactComponent as BookmarkIcon } from './icons/bookmark.svg';
import { ReactComponent as ThumbsUpIcon } from './icons/thumbs-up.svg';
import { ReactComponent as ThumbsDownIcon } from './icons/thumbs-down.svg';
import { ReactComponent as ShareIcon } from './icons/share.svg';
import { ReactComponent as CommentIcon } from './icons/comment.svg';
import ExampleAvatar from 'common/images/example-avatar.png';
import Image1 from './images/image1.png';
import Image2 from './images/image2.png';
import Image3 from './images/image3.png';
import Image4 from './images/image4.png';
import Image8 from './images/image10.png';
import Image6 from './images/image6.png';
import Image7 from './images/image7.png';
import IconButton from 'common/components/IconButton';
import { ReactComponent as CommentImageIcon } from './icons/comment-image.svg';
//import { ReactComponent as CommentGifIcon } from './icons/comment-gif.svg';
import { ReactComponent as CommentEmojiIcon } from './icons/comment-emoji.svg';
import { ReactComponent as CommentStickerIcon } from './icons/comment-sticker.svg';
import { ReactComponent as CommentSendIcon } from './icons/comment-send.svg';
import TextArea from 'common/components/TextArea';
import NavLinkButton from 'common/components/NavLinkButton';
import Input from 'common/components/Input';
import { useAuth } from 'common/context/AuthContext';
import Cookies from 'universal-cookie';

const AccountBanner = styled.div`
    height: 200px;
    width: 100%;
    border-radius: 4px;
    background: url(${Banner}), lightgray 0px -343.203px / 100% 534.594% no-repeat;
    position: relative;
    overflow: hidden;
    background-size: cover;
`;
const BannerColor = styled.div`
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: ${(props) => props.theme.colors.primaryColor};
    opacity: .5;
`;
const Box = styled.div`
    display:flex;
    flex-direction:column;
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
`;

const PostWrapper = styled.div`
    display:flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: calc(100vw - 509px);
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    overflow: hidden;
`;

const PostButtonText = styled.span`
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
    letter-spacing: 1px;
    color: ${(props) => props.theme.colors.primaryTextColor};
`;

const PostButtonWrapper = styled.button<{ dataFill?: boolean }>`
    display:flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px 24px;
    height: 44px;
    max-height: 44px;
    border-radius: 8px;
    transition: all 0.2s ease-in-out;
    border: 1px solid ${(props) => props.theme.colors.gray};
    &:hover {
        border-color: ${(props) => props.theme.colors.primaryColor};
    }
    &.active {
        border-color: ${(props) => props.theme.colors.primaryColor};
        & path {
            ${(props) => props.dataFill && 'fill: ' + props.theme.colors.primaryColor + ' !important;'}
            ${(props) => !props.dataFill && 'stroke: ' + props.theme.colors.primaryColor + ' !important;'}
        }
    }
`;

const InvisibleTextArea = styled.input`
    width: 100%;
    height: 20px;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
    letter-spacing: 1px;
    resize: none;
    color: ${(props) => props.theme.colors.primaryTextColor};
    &::placeholder {
        color: ${(props) => props.theme.colors.gray};
    }
`;

const CreatePostWrapper = styled.div`
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    display:flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

const CreatePost = () => {
  const theme = useTheme();
  const [vacancyValue, setVacancyValue] = useState('' as string);
  const [postValue, setPostValue] = useState('');
  const onPostValueChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setPostValue(e.target.value);
  };
  const onVacancyValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVacancyValue(e.target.value);
  };
  const [isVacancy, setIsVacancy] = useState(false);
  return (
        <CreatePostWrapper>
            <div className='account-create-post-top-line'>
                <p className='new-p'>Оберіть тип поста:</p>
                <TableNavButton onClick={()=>{setIsVacancy(false);}} style={{ height: '36px', fontSize: '16px' }} className={!isVacancy ? 'active' : ''}>Публікація</TableNavButton>
                <TableNavButton onClick={()=>{setIsVacancy(true);}} style={{ height: '36px', fontSize: '16px' }} className={isVacancy ? 'active' : ''}>Вакансія</TableNavButton>
            </div>
            {isVacancy && <Input value={vacancyValue} onChange={onVacancyValueChange} placeholder='Назва вакансії' />}
            <TextArea height={'104px'} placeholder={isVacancy ? 'Опишіть вакансію' : 'Розкажіть про ваші події та новини'} value={postValue} onChange={onPostValueChange} />
            <div className='account-post-comment-input-buttons'>
                <CommentImageIcon className='svg-black' />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M16.8 20C17.4543 20 17.9176 20 18.275 19.9565C18.5293 19.9256 18.7301 19.8727 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V16.8V16.4934V7.2V7.19999C20 6.0799 20 5.51984 19.782 5.09202C19.5903 4.71569 19.2843 4.40973 18.908 4.21799C18.4802 4 17.9201 4 16.8 4H7.2C6.07989 4 5.51984 4 5.09202 4.21799C4.71569 4.40973 4.40973 4.71569 4.21799 5.09202C4 5.51984 4 6.0799 4 7.2V16.8C4 17.4575 4 17.9221 4.04409 18.2801C4.07512 18.5321 4.12796 18.7313 4.21799 18.908C4.40973 19.2843 4.71569 19.5903 5.09202 19.782C5.51984 20 6.07989 20 7.19998 20H7.2H16.8Z" stroke={theme.colors.black} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8.53894 14.0713C8.03494 14.0713 7.60894 13.9813 7.26094 13.8013C6.91694 13.6173 6.65494 13.3633 6.47494 13.0393C6.29894 12.7113 6.21094 12.3353 6.21094 11.9113C6.21094 11.4633 6.30894 11.0733 6.50494 10.7413C6.70494 10.4093 6.99094 10.1533 7.36294 9.97327C7.73494 9.78927 8.18094 9.69727 8.70094 9.69727C9.00494 9.69727 9.27694 9.73127 9.51694 9.79927C9.68807 9.84415 9.84051 9.9038 9.97426 9.9782C10.0728 10.033 10.1066 10.1542 10.0659 10.2594L9.85668 10.7986C9.80115 10.9418 9.63157 10.9994 9.49059 10.9385C9.46081 10.9256 9.43159 10.9139 9.40294 10.9033C9.29894 10.8633 9.19294 10.8353 9.08494 10.8193C8.97694 10.8033 8.85294 10.7953 8.71294 10.7953C8.32094 10.7953 8.03094 10.8893 7.84294 11.0773C7.65894 11.2653 7.56694 11.5433 7.56694 11.9113C7.56694 12.2713 7.64894 12.5433 7.81294 12.7273C7.98094 12.9073 8.24694 12.9973 8.61094 12.9973C8.71494 12.9973 8.83294 12.9873 8.96494 12.9673C9.0476 12.9551 9.13174 12.9393 9.21735 12.9197C9.28168 12.905 9.33607 12.9724 9.30592 13.031V13.031C9.26963 13.1017 9.16294 13.0758 9.16294 12.9964V12.6184C9.16294 12.5261 9.08811 12.4513 8.99581 12.4513H8.60294C8.46487 12.4513 8.35294 12.3393 8.35294 12.2013V11.8133C8.35294 11.6752 8.46487 11.5633 8.60294 11.5633H9.96294C10.101 11.5633 10.2129 11.6752 10.2129 11.8133V13.5689C10.2129 13.6666 10.1563 13.7561 10.0657 13.7926C9.86293 13.8742 9.64602 13.9391 9.41494 13.9873C9.12694 14.0433 8.83494 14.0713 8.53894 14.0713Z" fill={theme.colors.black} />
                    <path d="M12.0981 13.9993C11.96 13.9993 11.8481 13.8873 11.8481 13.7493V10.0193C11.8481 9.88119 11.96 9.76927 12.0981 9.76927H12.8941C13.0322 9.76927 13.1441 9.88119 13.1441 10.0193V13.7493C13.1441 13.8873 13.0322 13.9993 12.8941 13.9993H12.0981Z" fill={theme.colors.black} />
                    <path d="M15.0903 13.9993C14.9522 13.9993 14.8403 13.8873 14.8403 13.7493V10.0193C14.8403 9.88119 14.9522 9.76927 15.0903 9.76927H17.6623C17.8004 9.76927 17.9123 9.88119 17.9123 10.0193V10.5033C17.9123 10.6413 17.8004 10.7533 17.6623 10.7533H16.3863C16.2482 10.7533 16.1363 10.8652 16.1363 11.0033V11.1633C16.1363 11.3013 16.2482 11.4133 16.3863 11.4133H17.5183C17.6564 11.4133 17.7683 11.5252 17.7683 11.6633V12.1473C17.7683 12.2853 17.6564 12.3973 17.5183 12.3973H16.3863C16.2482 12.3973 16.1363 12.5092 16.1363 12.6473V13.7493C16.1363 13.8873 16.0244 13.9993 15.8863 13.9993H15.0903Z" fill={theme.colors.black} />
                </svg>
                <CommentEmojiIcon className='svg-black' />
                <LocationIcon className='svg-black svg-fill' />
                <CommentSendIcon style={{ marginLeft: 'auto' }} className='svg-black' />
            </div>
        </CreatePostWrapper>
  );
};

const Post = () => {
  const theme = useTheme();
  const [areCommentsOpen, setAreCommentsOpen] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);
  const [isPostSaved, setIsPostSaved] = useState(false);

  const Comment = () => {
    const [isCommentLiked, setIsCommentLiked] = useState(false);
    return (
            <div className='account-post-comment-wrapper'>
                <div style={{ border: `1px solid ${theme.colors.gray}` }} className='account-post-user-avatar-wrapper account-post-comment-avatar'>
                    <img src={ExampleAvatar} />
                </div>
                <div className='account-post-comment-content'>
                    <div className='account-post-comment-top'>
                        <span className='account-post-comment-name'>Хімчистка KIMS</span>
                        <span className='account-post-comment-date'>4 д</span>
                    </div>
                    <div className='account-post-comment-text'>
                        <span>Ми дуже раді, що вам сподобався наш сервіс! Сподіваємося, що наші персональні менеджери та технологи зможуть зробити ваш досвід з КІМС ще дивовижнішим. Якщо у вас є якісь питання або потрібна додаткова інформація, не соромтеся ставити! Ми тут, щоб допомогти. 🤗💙</span>
                    </div>
                    <span className='account-post-comment-reply gray-text'>Відповісти</span>
                </div>
                <div onClick={() => { setIsCommentLiked(!isCommentLiked); }} className='account-post-like-wrapper'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        {isCommentLiked && <path d="M12.8778 4C15.3433 4 17 6.31778 17 8.48C17 12.8589 10.1244 16.4444 10 16.4444C9.87556 16.4444 3 12.8589 3 8.48C3 6.31778 4.65667 4 7.12222 4C8.53778 4 9.46333 4.70778 10 5.33C10.5367 4.70778 11.4622 4 12.8778 4Z" fill="#F90B0B" fillOpacity="0.6" />}
                        <path d="M12.8778 4C15.3433 4 17 6.31778 17 8.48C17 12.8589 10.1244 16.4444 10 16.4444C9.87556 16.4444 3 12.8589 3 8.48C3 6.31778 4.65667 4 7.12222 4C8.53778 4 9.46333 4.70778 10 5.33C10.5367 4.70778 11.4622 4 12.8778 4Z" stroke={theme.colors.black} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span style={{ fontWeight: isCommentLiked ? 500 : 400 }}>{isCommentLiked ? 2 : 1}</span>
                </div>
            </div>
    );
  };

  return (
        <PostWrapper>
            <div className='account-post-top-line'>
                <div className='account-post-user-wrapper'>
                    <div style={{ border: `1px solid ${theme.colors.gray}` }} className='account-post-user-avatar-wrapper'>
                        <SmallKimsLogo />
                    </div>
                    <div className='account-post-user'>
                        <span className='account-post-user-name'>Хімчистка KIMS</span>
                        <div style={{ backgroundColor: theme.colors.primaryColor }} className='account-post-verification-wrapper'>
                            <CheckIcon width={16} height={16} stroke={theme.colors.plainBackgroundColor} />
                        </div>
                    </div>
                </div>
                <div className='account-post-top-right'>
                    <span className='account-user-followers-wrapper'>4 д.</span>
                    <IconButton>
                        <HorizontalDotsIcon className='svg-black' />
                    </IconButton>
                </div>
            </div>
            <div
                className='account-post-text-content'
                dangerouslySetInnerHTML={{
                  __html: `Сьогодні відзначається всесвітній день рециклінгу<br />
                         Свято яке покликане привернути увагу до важливості перероблення вторинної сировини та розумного використання природних ресурсів.<br />
                         За останні 30 років людство вже витратило ТРЕТИНУ всіх наявних ресурсів Землі , а отже теми свідомого споживання ресурсів та рециклювання як ніколи важливі...<br />
                         ` }}
            >
            </div>
            <div className='account-post-image-wrapper'>
                <img width={'100%'} src={Image4} />
                <div style={{ backgroundColor: theme.colors.primaryColor + '80' }} className='account-post-image-overlay'>
                    <PlayIcon />
                </div>
            </div>
            <div className='account-post-bottom-line'>
                <div className='account-post-buttons'>
                    <PostButtonWrapper dataFill className={isLiked ? 'active' : ''} onClick={() => { setIsLiked(!isLiked); setIsDisliked(false); }}>
                        <ThumbsUpIcon className='svg-black' />
                        <PostButtonText>{isLiked ? 237 : 236}</PostButtonText>
                    </PostButtonWrapper>
                    <PostButtonWrapper dataFill className={isDisliked ? 'active' : ''} onClick={() => { setIsDisliked(!isDisliked); setIsLiked(false); }}>
                        <ThumbsDownIcon className='svg-black' />
                        <PostButtonText>{isDisliked ? 12 : 11}</PostButtonText>
                    </PostButtonWrapper>
                    <PostButtonWrapper className={areCommentsOpen ? 'active' : ''} onClick={() => { setAreCommentsOpen(!areCommentsOpen); }}>
                        <CommentIcon className='svg-black' />
                        <PostButtonText>35</PostButtonText>
                    </PostButtonWrapper>
                    <PostButtonWrapper dataFill>
                        <ShareIcon className='svg-black svg-fill' />
                        <PostButtonText>12</PostButtonText>
                    </PostButtonWrapper>
                </div>
                <IconButton size={44} onClick={() => { setIsPostSaved(!isPostSaved); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 16L19 21V2H5V21L12 16Z" fill={isPostSaved ? theme.colors.primaryColor : 'transparent'} stroke={theme.colors.black} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
            </div>
            {areCommentsOpen && <div className='account-post-comments'>
                <div className='account-post-comment-list'>
                    <Comment />
                </div>
                <Button label='Дивитись ще 30 відповідей' />
                <div className='account-post-comment-input-wrapper'>
                    <div style={{ border: `1px solid ${theme.colors.gray}` }} className='account-post-user-avatar-wrapper account-post-comment-avatar'>
                        <SmallKimsLogo />
                    </div>
                    <div style={{ border: `1px solid ${theme.colors.gray}` }} className='account-post-comment-input'>
                        <InvisibleTextArea className='u-fancy-scrollbar' placeholder='Напишіть коментар...' />
                        <div className='account-post-comment-input-buttons'>
                            <CommentImageIcon className='svg-black' />
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M16.8 20C17.4543 20 17.9176 20 18.275 19.9565C18.5293 19.9256 18.7301 19.8727 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V16.8V16.4934V7.2V7.19999C20 6.0799 20 5.51984 19.782 5.09202C19.5903 4.71569 19.2843 4.40973 18.908 4.21799C18.4802 4 17.9201 4 16.8 4H7.2C6.07989 4 5.51984 4 5.09202 4.21799C4.71569 4.40973 4.40973 4.71569 4.21799 5.09202C4 5.51984 4 6.0799 4 7.2V16.8C4 17.4575 4 17.9221 4.04409 18.2801C4.07512 18.5321 4.12796 18.7313 4.21799 18.908C4.40973 19.2843 4.71569 19.5903 5.09202 19.782C5.51984 20 6.07989 20 7.19998 20H7.2H16.8Z" stroke={theme.colors.black} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M8.53894 14.0713C8.03494 14.0713 7.60894 13.9813 7.26094 13.8013C6.91694 13.6173 6.65494 13.3633 6.47494 13.0393C6.29894 12.7113 6.21094 12.3353 6.21094 11.9113C6.21094 11.4633 6.30894 11.0733 6.50494 10.7413C6.70494 10.4093 6.99094 10.1533 7.36294 9.97327C7.73494 9.78927 8.18094 9.69727 8.70094 9.69727C9.00494 9.69727 9.27694 9.73127 9.51694 9.79927C9.68807 9.84415 9.84051 9.9038 9.97426 9.9782C10.0728 10.033 10.1066 10.1542 10.0659 10.2594L9.85668 10.7986C9.80115 10.9418 9.63157 10.9994 9.49059 10.9385C9.46081 10.9256 9.43159 10.9139 9.40294 10.9033C9.29894 10.8633 9.19294 10.8353 9.08494 10.8193C8.97694 10.8033 8.85294 10.7953 8.71294 10.7953C8.32094 10.7953 8.03094 10.8893 7.84294 11.0773C7.65894 11.2653 7.56694 11.5433 7.56694 11.9113C7.56694 12.2713 7.64894 12.5433 7.81294 12.7273C7.98094 12.9073 8.24694 12.9973 8.61094 12.9973C8.71494 12.9973 8.83294 12.9873 8.96494 12.9673C9.0476 12.9551 9.13174 12.9393 9.21735 12.9197C9.28168 12.905 9.33607 12.9724 9.30592 13.031V13.031C9.26963 13.1017 9.16294 13.0758 9.16294 12.9964V12.6184C9.16294 12.5261 9.08811 12.4513 8.99581 12.4513H8.60294C8.46487 12.4513 8.35294 12.3393 8.35294 12.2013V11.8133C8.35294 11.6752 8.46487 11.5633 8.60294 11.5633H9.96294C10.101 11.5633 10.2129 11.6752 10.2129 11.8133V13.5689C10.2129 13.6666 10.1563 13.7561 10.0657 13.7926C9.86293 13.8742 9.64602 13.9391 9.41494 13.9873C9.12694 14.0433 8.83494 14.0713 8.53894 14.0713Z" fill={theme.colors.black} />
                                <path d="M12.0981 13.9993C11.96 13.9993 11.8481 13.8873 11.8481 13.7493V10.0193C11.8481 9.88119 11.96 9.76927 12.0981 9.76927H12.8941C13.0322 9.76927 13.1441 9.88119 13.1441 10.0193V13.7493C13.1441 13.8873 13.0322 13.9993 12.8941 13.9993H12.0981Z" fill={theme.colors.black} />
                                <path d="M15.0903 13.9993C14.9522 13.9993 14.8403 13.8873 14.8403 13.7493V10.0193C14.8403 9.88119 14.9522 9.76927 15.0903 9.76927H17.6623C17.8004 9.76927 17.9123 9.88119 17.9123 10.0193V10.5033C17.9123 10.6413 17.8004 10.7533 17.6623 10.7533H16.3863C16.2482 10.7533 16.1363 10.8652 16.1363 11.0033V11.1633C16.1363 11.3013 16.2482 11.4133 16.3863 11.4133H17.5183C17.6564 11.4133 17.7683 11.5252 17.7683 11.6633V12.1473C17.7683 12.2853 17.6564 12.3973 17.5183 12.3973H16.3863C16.2482 12.3973 16.1363 12.5092 16.1363 12.6473V13.7493C16.1363 13.8873 16.0244 13.9993 15.8863 13.9993H15.0903Z" fill={theme.colors.black} />
                            </svg>
                            <CommentEmojiIcon className='svg-black' />
                            <CommentStickerIcon className='svg-black' />
                            <CommentSendIcon style={{ marginLeft: 'auto' }} className='svg-black' />
                        </div>
                    </div>
                </div>
            </div>}
        </PostWrapper>
  );
};

export default function AccountPage() {
  const theme = useTheme();
  const params = useParams();
  const navigate = useNavigate();
  const accountId = params.id || '';
  const { companyId } = useAuth();
  if (parseInt(accountId).toString() !== accountId) {
    if (companyId) {
      return <Navigate to={`/${companyId}`}/>;
    } else {
      const cookies = new Cookies();
      const tempId = cookies.get('companyId');
      if (tempId) {
        return <Navigate to={`/${tempId}`}/>;
      } else {
        return <Navigate to={'..'} />;
      }
    }
  }
  const location = useLocation();
  // get current link
  const currentLink = location.pathname.split('/').pop();
  console.log(currentLink);
  return (
        <div className="account-section">
            <AccountBanner>
                <BannerColor />
            </AccountBanner>
            <div className='account-top-line'>
                <div className='account-user-wrapper'>
                    <div className='account-avatar-wrapper'>
                        <KimsLogo />
                    </div>
                    <div className='account-user-content'>
                        <div className='account-user-name-wrapper'>
                            <div className='account-user-name'>
                                <span className='big-text'>Хімчистка KIMS</span>
                                <div style={{ backgroundColor: theme.colors.primaryColor }} className='account-verification-check'>
                                    <CheckIcon width={20} height={20} stroke={theme.colors.plainBackgroundColor} />
                                </div>
                            </div>
                            <span className='medium-title'>
                                Мережа хімчисток одягу та взуття
                            </span>
                        </div>
                        <div className='account-user-info-wrapper'>
                            <div className='account-user-followers-wrapper'>
                                <div className='account-user-followers'>
                                    <span>Читачі: </span>
                                    <span style={{ fontWeight: 500 }}>15,4 тис.</span>
                                </div>
                                <div className='account-user-followers'>
                                    <span>Робітники: </span>
                                    <span style={{ fontWeight: 500 }}>{numberWithSpaces(1545)}</span>
                                </div>
                            </div>
                            <span className='account-user-info-text'><span>Стежать </span><span style={{ fontWeight: 600 }}>Віталій Ш.</span><span>, </span><span style={{ fontWeight: 500 }}>Любов Р.</span><span> і ще 30</span></span>
                        </div>
                    </div>
                </div>
                <div className='account-line-end'>
                    <div className='account-line-socials-wrapper'>
                        <a className='account-line-socials-button'>
                            <FacebookLogo className='svg-black svg-fill' />
                        </a>
                        <a className='account-line-socials-button'>
                            <TwitterLogo className='svg-black svg-fill' />
                        </a>
                        <a className='account-line-socials-button'>
                            <InstagramLogo className='svg-black svg-fill' />
                        </a>
                        <a className='account-line-socials-button'>
                            <TelegramLogo className='svg-black svg-fill' />
                        </a>
                    </div>
                    <div className='account-line-buttons-wrapper'>
                        <Button primary label='Стежити' />
                        <Button label='Повідомлення' />
                    </div>
                </div>
            </div>

            <div className='account-navigation-wrapper'>
                <NavLinkButton
                    to=''
                    end
                >Публікації</NavLinkButton>
                <NavLinkButton
                    disabled
                    to='services'
                >Сервіс</NavLinkButton>
                <NavLinkButton
                    to='events'
                >Події</NavLinkButton>
                <NavLinkButton
                    to='gallery'
                >Галерея</NavLinkButton>
                <NavLinkButton
                    to='reminders'
                    disabled
                >Згадки</NavLinkButton>
                <NavLinkButton
                    to='reviews'
                    disabled
                >Відгуки</NavLinkButton>
                <NavLinkButton
                    to='vacancies'
                >Вакансії</NavLinkButton>
                <NavLinkButton
                    to='info'
                >Загальна інформація</NavLinkButton>
            </div>
            <div className='account-content-wrapper'>
                {currentLink !== 'info' &&
                <div className='account-side'>
                    <Box className='account-info-box'>
                        <span className='medium-title'>Кратка інформація</span>
                        <p className='new-p'>KIMS - передовий сервіс з чистки та ремонту одягу і взуття в Україні.</p>
                        <div className='account-info-list'>
                            <div className='account-info-line'>
                                <LocationIcon className='svg-black svg-fill' />
                                <p className='new-p'>Україна</p>
                            </div>
                            <div className='account-info-line'>
                                <PhoneIcon className='svg-black' />
                                <p className='new-p'>+{numberWithSpaces(380000000000)}</p>
                            </div>
                            <div className='account-info-line'>
                                <MailIcon className='svg-black' />
                                <p className='new-p'>kims@gmail.com</p>
                            </div>
                            <div className='account-info-line'>
                                <GlobeIcon className='svg-black' />
                                <p className='new-p'>kims.com.ua</p>
                            </div>
                            <div className='account-info-line'>
                                <StarIcon className='svg-black' />
                                <div className='account-rating-line'>
                                    <p className='new-p'>Оцінка</p>
                                    <div style={{ backgroundColor: theme.colors.primaryTextColor }}></div>
                                    <p className='new-p'>4,9 (3524 відгука)</p>
                                </div>
                            </div>
                        </div>
                    </Box>
                    <Box>
                        <span className='medium-title'>Галерея</span>
                        <div className='account-gallery-box-wrapper'>
                            <div className='account-gallery-box-img'>
                                <img src={Image1} />
                            </div>
                            <div className='account-gallery-box-img'>
                                <img src={Image2} />
                            </div>
                            <div className='account-gallery-box-img'>
                                <img src={Image3} />
                            </div>
                            <div className='account-gallery-box-img'>
                                <img src={Image8} />
                            </div>
                            <div className='account-gallery-box-img'>
                                <img src={Image6} />
                            </div>
                            <div className='account-gallery-box-img'>
                                <img src={Image7} />
                                <div onClick={()=>{navigate('gallery');}} style={{ backgroundColor: theme.colors.primaryColor + '80' }} className='account-gallery-box-more'>
                                    9+
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>}
                <div className='account-content'>
                    <Outlet />
                </div>
            </div>
        </div>
  );
}

export function AccountPosts() {
  return (
        <div className='account-posts-wrapper'>
            <CreatePost />
            <Post />
        </div>
  );
}